import React from "react";
import { defineMessages } from "react-intl";
import { Section } from "react-native-responsive-layout";
import { withTheme } from "styled-components/native";
import { string as yupString, object as yupObject, array as yupArray } from "yup";
import { FormGeneralStatusField } from "cci-admin";
import { FormCell, FormTextField, FormTextAreaField, Button } from "cci-component";
import {
  findUserGroupByIdQuery,
  saveUserGroupMutation,
  deleteUserGroupMutation
} from "cci-data";
import MutableInspect from "../../inspect/MutableInspect";

const messages = defineMessages({
  userGroup: {
    id: "userGroup",
    defaultMessage: "User Group"
  },

  name: {
    id: "name",
    defaultMessage: "Name"
  },

  description: {
    id: "description",
    defaultMessage: "Description"
  }
});

/**
 * Inspect component for the UserGroup entity, allows the user to create, edit or delete records if they have permission to do so.
 */
const Inspect = ({ theme, ...restProps }) => (
  <MutableInspect
    title={messages.userGroup}
    entityName="UserGroup"

    query={findUserGroupByIdQuery}
    queryName="findUserGroupById"

    mutation={saveUserGroupMutation}
    mutationName="saveUserGroup"
    objectWrapper="userGroup"
    defaultValues={{
      status: "active"
    }}
    validationSchema={yupObject().shape({
      name: yupString().required(),
      description: yupString().required()
    })}

    deleteMutation={deleteUserGroupMutation}

    {...restProps}
  >
    {() => (
      <React.Fragment>
        <Section>
          {/* Name */}
          <FormCell size="stretch">
            <FormTextField
              label={messages.name}
              name="name"
            />
          </FormCell>

          {/* Status */}
          <FormCell xlSize={150}>
            <FormGeneralStatusField />
          </FormCell>
        </Section>

        <Section>
          {/* Description */}
          <FormCell size="stretch">
            <FormTextAreaField
              label={messages.description}
              name="description"
            />
          </FormCell>
        </Section>
      </React.Fragment>
    )}
  </MutableInspect>
);

export default withTheme(Inspect);
